"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Constants for streaming payloads.
 */
var PayloadConstants;
(function (PayloadConstants) {
    PayloadConstants[PayloadConstants["MaxPayloadLength"] = 4096] = "MaxPayloadLength";
    PayloadConstants[PayloadConstants["MaxHeaderLength"] = 48] = "MaxHeaderLength";
    PayloadConstants[PayloadConstants["MaxLength"] = 999999] = "MaxLength";
    PayloadConstants[PayloadConstants["MinLength"] = 0] = "MinLength";
})(PayloadConstants = exports.PayloadConstants || (exports.PayloadConstants = {}));
//# sourceMappingURL=payloadConstants.js.map